'use strict';

class MobileMenu {

	/**
	 * Constructor method
	 */
	constructor() {

		// IE(11) polyfills
		this.polyfillIECustomEvent();
		this.polyfillIEForEach();

		// Mobile Menu
		this.menu = document.getElementById('mobile-menu');
		if (!this.menu) return;

		// Container for menu toggle button texts
		this.menuToggleTexts = {
			'true': this.menu.getAttribute('data-toggle-true'),
			'false': this.menu.getAttribute('data-toggle-false'),
		};

		// Container for menu toggle button icon classes
		this.menuToggleIconClasses = {
			'true': 'icon-plus',
			'false': 'icon-cancel'
		};

		// Selectors, classes, and IDs for the mobile menu
		this.menuItemSelector = '.menu-mobile .menu-mobile__item--has-children';
		this.menuItemClassActive = 'menu-mobile__item--current';
		this.menuIDPrefix = 'js-toggle-menu--';
		this.menuToggleClass = 'menu-mobile__item__toggle';
	}

	/**
	 * Provide polyfill for CustomEvent in IE(11)
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
	 */
	polyfillIECustomEvent() {
		(function () {
			if (typeof window.CustomEvent === "function") return false;
			function CustomEvent(event, params) {
				params = params || { bubbles: false, cancelable: false, detail: null };
				var evt = document.createEvent('CustomEvent');
				evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
				return evt;
			}
			window.CustomEvent = CustomEvent;
		})();
	}

	/**
	 * Provide polyfill for NodeList.forEAch in IE(11)
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach#Polyfill
	 */
	polyfillIEForEach() {
		if (window.NodeList && !NodeList.prototype.forEach) {
			NodeList.prototype.forEach = Array.prototype.forEach;
		}
	}

	/**
	 * Init method
	 */
	init() {

		// Bail out early if no mobile menu found.
		if (!this.menu) {
			// Trigger the init done event in case some third party is waiting for this to happen.
			document.dispatchEvent(new CustomEvent('mobilemenu-init-done'));
			return;
		}

		// Find menu items and create toggles
		document.querySelectorAll(this.menuItemSelector).forEach((menuItem, index) => {

			// Get menu
			const menu = menuItem.nextSibling;
			if (!menu) return;
			const menuID = this.menuIDPrefix + index;
			menu.setAttribute('id', menuID);

			// Hide menu
			if (!menuItem.classList.contains(this.menuItemClassActive) && !menu.querySelectorAll('.' + this.menuItemClassActive).length) {
				menu.hidden = true;
			}

			// Create toggle button
			const menuToggle = document.createElement('button');
			menuToggle.classList.add(this.menuToggleClass);
			menuToggle.setAttribute('aria-controls', menuID);
			const menuToggleSpan = document.createElement('span');
			menuToggleSpan.classList.add('sr-only');
			menuToggle.appendChild(menuToggleSpan);
			const menuToggleText = document.createTextNode(this.menuToggleTexts[menu.hidden]);
			menuToggleSpan.appendChild(menuToggleText);
			const menuToggleIcon = document.createElement('i');
			menuToggleIcon.setAttribute('aria-hidden', true);
			menuToggleIcon.classList.add(this.menuToggleIconClasses[menu.hidden]);
			menuToggle.appendChild(menuToggleIcon);

			// Add menu toggle button click event listener
			menuToggle.addEventListener('click', () => {
				this.togglemenu(menu, menuToggle, menuToggleText, menuToggleIcon, !menu.hidden);
			});

			// Add menu toggle button keydown event listener
			menuToggle.addEventListener('keydown', (event) => {
				let hiddenState;
				// 40 = down, 38 = up, 13 = enter, 32 = space
				if ([40, 38, 13, 32].indexOf(event.keyCode) > -1) {
					event.preventDefault();
					hiddenState = event.keyCode === 40 ? false : (event.keyCode === 38 ? true : !menu.hidden);
					this.togglemenu(menu, menuToggle, menuToggleText, menuToggleIcon, hiddenState);
				}
			});

			// Insert toggle before menu item
			menuItem.parentNode.insertBefore(menuToggle, menuItem.nextSibling);
		});

		// Trigger event when menu has been initialized.
		this.menu.dispatchEvent(new CustomEvent('mobilemenu-init-done', {
			bubbles: true,
			cancelable: true
		}));
	}

	/**
	 * Helper function for displaying or hiding a menu.
	 *
	 * @param {object} menu
	 * @param {object} menuToggle
	 * @param {string} menuToggleText
	 * @param {object} menuToggleIcon
	 * @param {bool} hiddenState
	 */
	togglemenu(menu, menuToggle, menuToggleText, menuToggleIcon, hiddenState) {
		menu.hidden = hiddenState;
		menuToggle.setAttribute('aria-expanded', !menu.hidden);
		menuToggleText.nodeValue = this.menuToggleTexts[menu.hidden];
		menuToggleIcon.classList.remove(this.menuToggleIconClasses[!menu.hidden]);
		menuToggleIcon.classList.add(this.menuToggleIconClasses[menu.hidden]);
	}

}
